<template>
  <div class="barBox" ref="chart"></div>
</template>

<script>
import echarts from 'echarts'
import debounce from '@/utils/debounce'

export default {
  name: 'barDemo',
  data () {
    return {
      myChart: null,
      defaultOptions: {
        color: [],
        tooltip: {
          tooltip: {
            trigger: 'axis'
          }
        },
        legend: {
          top: 2,
          itemWidth: 8,
          itemHeight: 8,
          padding: [0, 0, 5, 0],
          icon: 'rect',
          textStyle: {
            color: '#8794A4'
          }
        },
        grid: {
          top: '15%',
          right: '15%',
          bottom: '25%',
          left: '15%'
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            },
            axisLine: {
              lineStyle: {
                color: '#8794A4'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              // showMaxLabel: true,
              // showMinLabel: true,
              // interval: 0,
              rotate: 30,
              textStyle: {
                fontSize: 12 // 调整x轴字体大小px
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            axisLine: {
              lineStyle: {
                color: '#8794A4'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          {
            type: 'value',
            name: '',
            min: 0,
            show: true,
            axisLine: {
              lineStyle: {
                color: '#8794A4'
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: []
      }
    }
  },
  props: {
    chartData: {
      default: () => {}
    },
    dontNeedRightYaxis: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    // this.resizeData(this.chartData)
  },
  methods: {
    resizeChange () {
      window.addEventListener('resize', debounce(this.myChart.resize, 200))
    },
    resizeData (val) {
      // let _this = this
      this.defaultOptions = val
      this.myChart = echarts.init(this.$refs.chart)

      this.myChart.setOption(this.defaultOptions)
      this.resizeChange()
    },
    setData (val) {
      val.series.forEach((i, index) => {
        this.defaultOptions.series[index].name = i.name
        this.defaultOptions.series[index].data = i.data
      })
      this.myChart.setOption(this.defaultOptions)
    }
  },
  watch: {
    chartData: {
      handler (val) {
        this.resizeData(val)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scpoed>
.barBox {
  width: 100%;
  height: 100%;
}
</style>
